import { Routes } from '@angular/router';

import { ErrorComponent } from './error/error.component';
import { IsAuthenticatedGuard } from './services/auth/is-authenticated.guard';
import { AppRoutes } from "./approutes.enum";


export const ROUTES: Routes = [{
   path: '', redirectTo: AppRoutes.Application, pathMatch: 'full'
  },
  {
    path: AppRoutes.Application,
    canActivateChild: [IsAuthenticatedGuard],
    loadChildren: () => import('./layout/layout.module').then((m) => m.LayoutModule)
  },
  {
    path: AppRoutes.Login, loadChildren: () => import('./login/login.module').then((m) => m.LoginModule)
  },
  {
    path: AppRoutes.Error, component: ErrorComponent
  },
  {
    path: '**', component: ErrorComponent
  }
];
